module.exports = __webpack_public_path__ + "static/media/key.fc7e20bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/key.png
// module id = 2306
// module chunks = 0